import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-or-later
import { useId, useEffect } from 'react';
import { describedBy, FieldHost } from '../FieldHost.js';
import { useLanguage } from '../../i18n/LanguageProvider.js';
import { translateAnswerOption } from '../../i18n/translate.js';
import { answerOptionKey, answerOptionLabel, asAnswerOption } from './answerOption.js';
export function SingleSelect(props) {
    const { item, value, errors, disabled, onChange } = props;
    const { lang, t } = useLanguage();
    const id = useId();
    const options = item.answerOption ?? [];
    const current = asAnswerOption(value, options);
    const currentKey = current === undefined ? '' : answerOptionKey(current);
    useEffect(() => {
        if (value !== undefined && current !== undefined && value !== current) {
            onChange(current);
        }
    }, [value, current, onChange]);
    return (_jsx(FieldHost, { item: item, errors: errors, controlId: id, children: (ctx) => (_jsxs("select", { id: id, value: currentKey, disabled: disabled === true, required: item.required === true, "aria-invalid": ctx.hasError || undefined, "aria-describedby": describedBy(ctx), onChange: (e) => {
                const key = e.currentTarget.value;
                if (key === '') {
                    onChange(undefined);
                    return;
                }
                const next = options.find((o) => answerOptionKey(o) === key);
                onChange(next);
            }, children: [_jsx("option", { value: "", children: t('fields.select-placeholder') }), options.map((o) => {
                    const key = answerOptionKey(o);
                    return (_jsx("option", { value: key, children: translateAnswerOption(item, key, answerOptionLabel(o), lang) }, key));
                })] })) }));
}
//# sourceMappingURL=SingleSelect.js.map